// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__3cSYL","upload":"Small_upload__3z-Mn","imageWrap":"Small_imageWrap__3dFl-","removeBtn":"Small_removeBtn__hdfsa"};